import useSWR from 'swr'
import { guardClient } from '../_axios'

export type FocusDeal = {
  id: number
  title: string
  content: string | null
  expectedSales: string | null
  expectedProfit: string | null
  jobType: 'RA' | 'CA'
  companyId: number
  organizationId: number
  company: { id: number; name: string }
  createdAt: string
  updatedAt: string
}

type FocusDealsFilter = {
  companyId?: number
  jobType?: 'RA' | 'CA'
}

const fetcher = (url: string) =>
  guardClient.get<{ data: FocusDeal[] }>(url).then((r) => r.data.data)

export const useFocusDeals = (filter: FocusDealsFilter = {}) => {
  const params = new URLSearchParams()
  if (filter.companyId != null) params.set('companyId', String(filter.companyId))
  if (filter.jobType != null) params.set('jobType', filter.jobType)
  const query = params.toString()
  const path = `/focus-deals${query ? '?' + query : ''}`

  const { data, mutate } = useSWR(path, fetcher, {
    onErrorRetry: () => { return }
  })
  return { data: data ?? [], mutate }
}
